import styled from "@emotion/styled";
import { useState } from "react";
import { createPortal } from "react-dom";
import { Modal } from "./Modal";
import { Modal2 } from "./Modal2";

const Icon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
  :active {
    transform: scale(0.9);
  }
`;

export const CopyIcon = ({ text }: { text: string }) => {
  const [open, setOpen] = useState(false);



  return (
    <>
    <Icon
      src="/copy.svg"
      onClick={async () => {
        await window.navigator.clipboard.writeText(text); 
        setOpen(true);
      }}
    />
    <Modal2
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      복사되었습니다
    </Modal2>
    </>
  );
};
